/**
 * @class MediaVideo
 * @classdesc Handles creating a video media element
 *
 * @extends Core.Component
 */
export default class MediaVideo extends Core.Component {
  constructor(el, context) {
    super(el, context);

    const videoEl = this.el.querySelector('video');

    this._video = Core.Media.createVideo(videoEl, 'html5');
  }

  /**
   * Play the media
   * @public
   */
  pause() {
    this._video.pause();
  }

  /**
   * Pause the media
   * @public
   */
  play() {
    this._video.play();
  }
}
